import Tooltip from "@vapor/react-material/Tooltip";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";

export function CervedDiffIcon({ diff }) {
    if (!diff?.hasDifference) {
        return null;
    }

    return (
        <Tooltip
            title={
                <>                    
                    <div>
                        <strong>Modefinance:</strong> {diff.cervedValue || "-"}
                    </div>
                </>
            }
        >
            <WarningAmberIcon
                color="warning"
                fontSize="small"
                sx={{ ml: 0.5, verticalAlign: "middle" }}
            />
        </Tooltip>
    );
}